import React from "react";
import { Button } from "react-bootstrap";
import { TABS } from "../utils/tabs";

// Per the prototype's empty states: the free-tier copy REPLACES the title
// rather than sitting under it, and the upsell belongs to Needs Attention only
// — Upcoming keeps its own empty state whatever the tier.
const JobsEmptyState = ({ tab, isFreeUser = false, onCreate, onUpgrade }) => {
  if (tab === TABS.NEEDS_ATTENTION) {
    if (isFreeUser) {
      return (
        <div className="jobs-empty-state">
          <p className="jobs-empty-message">
            Upgrade to stay on top of contract, payment, and email status here.
          </p>
          {onUpgrade && (
            <Button variant="primary" onClick={onUpgrade}>
              Upgrade Now
            </Button>
          )}
        </div>
      );
    }
    return (
      <div className="jobs-empty-state">
        <p className="jobs-empty-message">Nothing needs attention right now.</p>
      </div>
    );
  }

  return (
    <div className="jobs-empty-state">
      <p className="jobs-empty-message">Nothing scheduled for now.</p>
      {onCreate && (
        <Button variant="primary" onClick={onCreate}>
          + Job
        </Button>
      )}
    </div>
  );
};

export default JobsEmptyState;
